import { useContext } from "react";
import { openFeatureStateContext } from "../../context";

export const useOpenFeatureState = () => {
  const { loading, error, flagsState, addFlagToContext, onFlagsChangeHandler } =
    useContext(openFeatureStateContext);

  return { loading, error, flagsState, addFlagToContext, onFlagsChangeHandler };
};
